var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition-group", { attrs: { name: "fade-absolute" } }, [
    _vm.loading
      ? _c("div", { key: "loading", staticClass: "flex justify-center" }, [
          _c(
            "div",
            {
              staticClass:
                "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
            },
            [
              _c("i", {
                staticClass:
                  "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
              }),
            ]
          ),
        ])
      : _vm.products.length
      ? _c(
          "div",
          {
            key: "products",
            staticClass: "relative",
            class: { "my-lg": _vm.search !== undefined },
          },
          [
            _vm.search !== undefined
              ? _c("div", [
                  _c(
                    "span",
                    { staticClass: "font-semibold inline-block mb-xxs" },
                    [_vm._v("Zoekresultaten")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "productcontainer",
                staticClass: "-m-sm flex flex-wrap",
                class: { /*'justify-center'*/ "": _vm.products.length < 4 },
              },
              [
                _vm._l(_vm.products, function (product) {
                  return _c(
                    "div",
                    {
                      key: product.id,
                      staticClass: "w-1/2 p-sm sm:w-1/3 md:w-1/4",
                    },
                    [
                      product && product.acf
                        ? [
                            _c(
                              "a",
                              {
                                staticClass: "block-img-hover block",
                                attrs: {
                                  href:
                                    _vm.possibleLangPrefix +
                                    "/product/" +
                                    product.slug,
                                },
                              },
                              [
                                _c("div", { staticClass: "relative" }, [
                                  _c("div", {
                                    class:
                                      _vm.orientation == "portrait"
                                        ? "aspect-w-2 aspect-h-3"
                                        : _vm.orientation == "landscape"
                                        ? "aspect-w-3 aspect-h-2"
                                        : "aspect-w-1 aspect-h-1",
                                  }),
                                  _vm._v(" "),
                                  product.acf.image
                                    ? _c(
                                        "picture",
                                        {
                                          staticClass:
                                            "absolute top-0 left-0 h-full w-full",
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "lazyload h-full w-full object-cover",
                                            attrs: {
                                              "data-src": product.acf.image.url,
                                              alt: product.title.rendered,
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "block-img-hover__icon" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa-regular fa-arrow-right",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-xs flex items-center w-full",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "text-xs xs:text-sm font-bold uppercase tracking-[2px] text-gray-300",
                                      class: {
                                        "do-not-translate":
                                          _vm.shouldNotTranslate(product),
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          product.title.rendered
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-full" },
                  [
                    _c("pagination", {
                      attrs: {
                        "current-page": _vm.params.page,
                        "total-pages": _vm.totalPages,
                      },
                      on: {
                        "next-page": function ($event) {
                          return _vm.filter(_vm.params.page + 1)
                        },
                        "previous-page": function ($event) {
                          return _vm.filter(_vm.params.page - 1)
                        },
                        "go-to-page": function (event) {
                          return _vm.filter(event.page)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        )
      : _vm.timeout === null && _vm.search && _vm.search.length
      ? _c("div", { key: "empty" }, [
          _c("p", { staticClass: "my-lg text-center" }, [
            _vm._v("Geen producten gevonden. Probeer een andere zoekopdracht."),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }